// extracted by mini-css-extract-plugin
module.exports = {"root":"RecoveryPasswordSuccess_root__Gqs8C","header":"RecoveryPasswordSuccess_header__2vHzk","text":"RecoveryPasswordSuccess_text__v-Sua"};